import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, Field, NumericInput, RadioGroup, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from '../../../../Layout';
import { IWorksheetComponent } from '../../../Core/types';
import { LinearShrinkageMeasureMethod } from '../../types';

let AsLinearShrinkageMeasurementsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const Curling = useSelector(createWorksheetSelector!('Measurements.Curling'));
  const UnableToMeasure = useSelector(createWorksheetSelector!('Measurements.UnableToMeasure'));
  const SoilBarMethodUsed = useSelector(
    pipe(
      createWorksheetSelector!('Measurements.MeasureMethod'),
      (method) => method === LinearShrinkageMeasureMethod.SoilBarLength
    )
  );

  return (
    <>
      <ListFieldSection heading="Observations">
        <FieldSet>
          <Field input={<Checkbox />} name="Measurements.Cracking" />
          <Field input={<Checkbox />} name="Measurements.Crumbling" />
          <Field input={<Checkbox />} name="Measurements.Curling" />
          <Field input={<Checkbox />} name="Measurements.UnableToMeasure" />
        </FieldSet>
      </ListFieldSection>
      <ListFieldSection heading="Measure" visible={!UnableToMeasure}>
        <Field
          input={<RadioGroup />}
          name="Measurements.MeasureMethod"
          visible={!Curling}
          options={[
            {
              label: 'Longitudinal shrinkage',
              value: LinearShrinkageMeasureMethod.Longitudinal,
            },
            { label: 'Soil bar length', value: LinearShrinkageMeasureMethod.SoilBarLength },
          ]}
        />
        <Field input={<NumericInput />} visible={Curling} name="Measurements.TopSurfaceLength" />
        <Field input={<NumericInput />} visible={Curling} name="Measurements.BottomSurfaceLength" />
      </ListFieldSection>
      <ListFieldSection>
        <Field input={<NumericInput />} visible={!Curling && SoilBarMethodUsed} name="Measurements.SoilBarLength" />
        <Field input={<TextOutput />} visible={!UnableToMeasure && Curling} name="Measurements.SoilBarLength" />
        {UnableToMeasure ? (
          <Field input={<TextOutput />} name="Measurements.LongitudinalShrinkageText" />
        ) : (
          <Field
            input={Curling || SoilBarMethodUsed ? <TextOutput /> : <NumericInput />}
            name="Measurements.LongitudinalShrinkage"
          />
        )}
      </ListFieldSection>
    </>
  );
};

AsLinearShrinkageMeasurementsSection = withInjectedProps(AsLinearShrinkageMeasurementsSection);

export { AsLinearShrinkageMeasurementsSection };
export default AsLinearShrinkageMeasurementsSection;
